import * as React from "react";
import MuiCollapse from "@material-ui/core/Collapse";
import type { UiBaseProps } from "../uiProps.utils";

export type CollapseProps = UiBaseProps & {
  open: boolean;
  durationMs?: number;
  // Drop the content from the page while closed, instead of keeping it at zero height.
  unmountOnClose?: boolean;
};

export const Collapse: React.FC<CollapseProps> = ({ open, durationMs, unmountOnClose, ...rest }) => (
  <MuiCollapse in={open} timeout={durationMs} unmountOnExit={unmountOnClose} {...rest} />
);
